// extracted by mini-css-extract-plugin
module.exports = {"interiorSeparationImgWrapper":"ShelvesSelector_interiorSeparationImgWrapper__htPV2"};